import { Dispatch, SetStateAction, useMemo } from 'react'
import { FormInstance, Typography } from 'antd'
import useGetAnnotationColor from 'hooks/useGetAnnotationColor'
import { useRecoilValue } from 'recoil'
import { hasLinkErrorState } from 'store/buildingStore'
import { AnnotationType, BuildingFile } from 'types/building'

import LeftArrowIcon from 'components/icons/LeftArrowIcon'

import FolderList from './FolderList'
import LinkSetting from './LinkSetting'

type Props = {
  form: FormInstance
  selectedFolder: AnnotationType
  selectedChildrenFolder: any
  childrenFolder: any
  dataSource: any
  handleBack: () => void
  setSelectedChildrenFolder: any
  setIsAddingFile: Dispatch<SetStateAction<boolean>>
  setExistsFile: Dispatch<SetStateAction<BuildingFile[]>>
  setPreviewFileIndex: Dispatch<SetStateAction<number | undefined>>
}

export default function AnnotationSetting({
  form,
  selectedFolder,
  selectedChildrenFolder,
  childrenFolder,
  setSelectedChildrenFolder,
  dataSource,
  handleBack,
  setIsAddingFile,
  setExistsFile,
  setPreviewFileIndex
}: Props) {
  const { getAnnotationBgColor } = useGetAnnotationColor()

  const annotationBgColor = useMemo(
    () => getAnnotationBgColor(selectedFolder),
    [getAnnotationBgColor, selectedFolder]
  )

  const hasLinkError = useRecoilValue(hasLinkErrorState)

  return (
    <div className="flex flex-col grow min-w-0 overflow-hidden">
      <div
        className={`flex h-[50px] ${annotationBgColor} items-center pl-6 
  ${selectedChildrenFolder ? 'gap-5 ' : ''}
  ${
    hasLinkError && selectedChildrenFolder?.id === 40
      ? 'cursor-not-allowed opacity-50'
      : 'cursor-pointer'
  }
`}
        onClick={handleBack}
      >
        {selectedChildrenFolder && <LeftArrowIcon size={20} />}
        <Typography className="font-bold leading-[23.17px] text-white">
          {selectedChildrenFolder
            ? selectedChildrenFolder.label
            : dataSource?.label}
        </Typography>
      </div>
      {selectedChildrenFolder?.id === 40 ? (
        <LinkSetting form={form} />
      ) : (
        <FolderList
          childrenFolder={childrenFolder}
          selectedChildrenFolder={selectedChildrenFolder}
          setSelectedChildrenFolder={setSelectedChildrenFolder}
          setIsAddingFile={setIsAddingFile}
          setExistsFile={setExistsFile}
          setPreviewFileIndex={setPreviewFileIndex}
        />
      )}
    </div>
  )
}
